import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import DeliveryFormItemWrapper from "./DeliveryFormItemWrapper";
import DeliveryAddressDivider from "./DeliveryAddressDivider";
import TextField from "./TextField";
function StreetAddressForm(props) {
    const { fieldId, controller, onChange, onBlur } = props;
    const { fields, isPostCodeRequired } = controller;
    const fieldIds = {
        street: `${fieldId}.street`,
        streetNumber: `${fieldId}.streetNumber`,
        city: `${fieldId}.city`,
        postCode: `${fieldId}.postCode`,
    };
    // Auto-detection for browser autocomplete/autofill (e.g., saved addresses, password managers)
    // When all required fields become valid without user interaction (controller.isTouched = false),
    // we trigger onBlur to immediately save and geocode the address. This provides seamless UX
    // and prevent from "not verified address state" errors in "inline edit" mode (Cart & Checkout)
    // where there's no explicit "Save address" button.
    const [isAutocompleted, setIsAutocompleted] = useState(false);
    useEffect(() => {
        if (!isAutocompleted &&
            !controller.isTouched &&
            controller.fields.city.isValid &&
            controller.fields.street.isValid &&
            controller.fields.streetNumber.isValid) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
            setIsAutocompleted(true);
        }
    }, [
        controller.fields.city.isValid,
        controller.fields.street.isValid,
        controller.fields.streetNumber.isValid,
        controller.isTouched,
        isAutocompleted,
        onBlur,
    ]);
    return (h(Fragment, null,
        h(DeliveryFormItemWrapper, { name: "street" },
            h(TextField, { name: fieldIds.street, dataFieldId: fieldIds.street, dataTestId: "deliveryAddress/street", label: translate(t.activerecord.attributes.delivery_address.street), controller: fields.street, required: true, autocomplete: "shipping address-line1", onChange: onChange, onBlur: onBlur })),
        h(DeliveryFormItemWrapper, { name: "street-number" },
            h(TextField, { name: fieldIds.streetNumber, dataFieldId: fieldIds.streetNumber, dataTestId: "deliveryAddress/streetNumber", label: translate(t.activerecord.attributes.delivery_address.street_number), controller: fields.streetNumber, required: true, autocomplete: "shipping address-line2", onChange: onChange, onBlur: onBlur })),
        h(DeliveryAddressDivider, null),
        h(DeliveryFormItemWrapper, { name: "city" },
            h(TextField, { name: fieldIds.city, dataFieldId: fieldIds.city, dataTestId: "deliveryAddress/city", label: translate(t.activerecord.attributes.delivery_address.city), controller: fields.city, required: true, autocomplete: "shipping address-level2", onChange: onChange, onBlur: onBlur })),
        isPostCodeRequired && (h(DeliveryFormItemWrapper, { name: "post-code" },
            h(TextField, { name: fieldIds.postCode, dataFieldId: fieldIds.postCode, label: translate(t.activerecord.attributes.delivery_address.post_code), controller: fields.postCode, required: true, autocomplete: "shipping postal-code", onChange: onChange, onBlur: onBlur })))));
}
export default observer(StreetAddressForm);
